import { Button, ButtonProps } from '@cloudscape-design/components';
import { useState } from 'react';
import { ExportFileConfig, ExportFileUtils } from 'src/utils/exportFileUtils';

// React Component
interface ExportButtonProps<T extends Record<string, any>> {
  data: T[];
  config?: ExportFileConfig;

  onError?: (error: any) => void;
  buttonText?: string;
  disabled?: boolean;
  buttonVariant?: ButtonProps.Variant;
}

export function ExportButton<T extends Record<string, any>>({
  data,
  config,
  onError,
  buttonText = 'Export',
  disabled = false,
  buttonVariant = 'primary',
}: ExportButtonProps<T>) {
  const [isExporting, setIsExporting] = useState(false);

  const handleExport = async () => {
    try {
      setIsExporting(true);
      ExportFileUtils.downloadCSV(data, config, onError);
    } catch (error) {
      if (error && onError) {
        onError(error);
      }
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <Button
      data-testid="export-button"
      variant={buttonVariant}
      onClick={handleExport}
      loading={isExporting}
      iconName="download"
      disabled={disabled || data.length === 0 || isExporting}
    >
      {isExporting ? 'Exporting...' : buttonText}
    </Button>
  );
}
